import Errors from './errors.js';

// Races `promise` against a timer so a hung network/subscription call surfaces as a rejection
// instead of leaving a UI stuck in a loading state forever.
export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Errors.RequestTimeout()), ms);

    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}

/**
 * A signal that aborts after `ms`, for an API that takes one (a fetch, a Web Locks request): AbortSignal.timeout where the
 * browser has it, otherwise an AbortController aborted by a timer; undefined where there is neither, so the caller goes on
 * without a timeout.
 */
export function timeoutSignal(ms: number): AbortSignal | undefined {
  if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') return AbortSignal.timeout(ms);
  if (typeof AbortController === 'undefined') return undefined;
  const controller = new AbortController();
  setTimeout(() => controller.abort(new DOMException('The operation timed out.', 'TimeoutError')), ms);
  return controller.signal;
}
